module.exports = __webpack_public_path__ + "img/lifestyle-style-allround.6b0a3e19.svg";